'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxLogger = require('./reduxLogger');

var reduxLogger = _interopRequireWildcard(_reduxLogger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  reduxLogger: reduxLogger
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-act/lib/loggers/index.js
// module id = 1164
// module chunks = 0